var map = {
	"./PrdTraceaDetails": [
		"sVen",
		0,
		7
	],
	"./PrdTraceaDetails.vue": [
		"sVen",
		0,
		7
	],
	"./PrdTraceabilityDetails": [
		"9nso",
		0,
		4
	],
	"./PrdTraceabilityDetails.vue": [
		"9nso",
		0,
		4
	],
	"./productDetails": [
		"2897",
		0,
		47
	],
	"./productDetails.vue": [
		"2897",
		0,
		47
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "SlMn";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/view/product/details lazy ^\.\/.*$
// module id = SlMn
// module chunks = 191